<template>
    <div class="pb-10 h-100 ml-2">
        <div class="d-flex flex-row flex-wrap justify-content-between align-items-center">
            <div class="breadcrumbactive">
                <div >
                    <span class="pointer" @click="goToCompanyList">Company</span>
                    <span>External Users</span>
                    <span class="text-capitalize" v-if="role != ''">{{role.replace('_',' ')}}</span>
                </div>
            </div>
            <div>
                <div class="d-flex flex-wrap align-items-center mr-2">
                    <div class="dropdown mr-3">
                        <a class="new-btn-brand-primary-report btn-wide dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Filter By
                            <i class="icon icon-chevron-down text-white fs-22"></i>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <span class="dropdown-item pointer" :class="{'text-secondary': role ==''}" v-if="role != ''" @click="filterBy('')">All</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role ==''}" v-else>All</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='consultant'}" v-if="role != 'consultant'" @click="filterBy('consultant')">Consultant</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='consultant'}" v-else>Consultant</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='advisor'}" v-if="role != 'advisor'" @click="filterBy('advisor')">Advisor</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='advisor'}" v-else>Advisor</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='investor'}" v-if="role != 'investor'" @click="filterBy('investor')">Investor</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='investor'}" v-else>Investor</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='banker'}" v-if="role != 'banker'" @click="filterBy('banker')">Banker</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='banker'}" v-else>Banker</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='supplier'}" v-if="role != 'supplier'" @click="filterBy('supplier')">Supplier</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='supplier'}" v-else>Supplier</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='board_member'}" v-if="role != 'board_member'" @click="filterBy('board_member')">Board Member</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='board_member'}" v-else>Board Member</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='share_holder'}" v-if="role != 'share_holder'" @click="filterBy('share_holder')">Share Holder</span>
                            <span class="dropdown-item pointer" :class="{'text-secondary': role =='share_holder'}" v-else>Share Holder</span>
                        </div>
                    </div>
                    <div class=" d-flex align-items-center" style="position: relative;width: 230px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;"></i>
                        <i v-if="search_key !=''" class="icon icon-close fs-20" style="position: absolute; right: 10px;color: #707070 !important;cursor: pointer;" @click="clearSearch"></i>
                        <input type="text" class="search-input-field" v-model="search_key" @input="loadStakeholder" placeholder="Search by Name" />
                    </div>
                    <!-- <button class="btn btn-smm btn-new-secondary" style="border: 0 !important;border-radius: 6px !important;" @click="showFilters()">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;">Filter
                    </button> -->
                    <button v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super_admin' || loggedInUser.user_role == 'super admin'" class="btn btn-smm btn-danger ml-3" style="border-radius: 6px !important;"  :disabled="consultant_selected.length < 1" @click="showDeleteComp">- Delete</button>
                    <button v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super_admin' || loggedInUser.user_role == 'super admin'" class="btn btn-smm text-white btn-success ml-3" style="border-radius: 6px !important;" @click="createNew">+
                        Create New External User
                    </button>
                </div>
            </div>
        </div>
        <div class="pr-2 pb-20">
            <div class="w-100">
                <!-- <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                        <div class="header-slant-tab">
                            <span class="text-secondary fs-14">List View</span>
                        </div>
                        <div class="header-slant-tab-border"></div>
                    </div>
                    <div class="ml-3 d-flex align-items-center w-100" style="position: relative;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;"></i>
                        <input type="text" class="search-input-field" v-model="search_key" @input="loadStakeholder" placeholder="Search by Consultant Name" />
                    </div>
                </div> -->
                <div class="table-start pt-8 pb-10" style="min-height: 30em;">
                    <table class="admin-new-table w-100" style="border-collapse: collapse; position: relative;padding-left:10px" width="100%">
                        <thead>
                            <tr>
                                <th class="text-center">
                                    <label v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super_admin' || loggedInUser.user_role == 'super admin'" :class="{'v-hidden':consultant_list.length == 0}" class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                        <input type="checkbox" v-model="check_all" class="custom-control-input" @change="checkAll" name="select_all" />
                                        <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                        <span class="form-check-description fw-600"></span>
                                    </label>
                                </th>
                                <th class="text-center"></th>
                                <th>Name</th>
                                <th></th>
                                <th>Personal Email ID</th>
                                <th>Role</th>
                                <th>Access Entry <br>Date and Time</th>
                                <th>Access End <br>Date and Time</th>
                                <th>Total Shares</th>
                                <th>Total Invested ({{currency_symbol}})</th>
                                <th class="text-center">Investments</th>
                                <th>Status</th>
                                <th>Password</th>
                                <th>Enable Access</th>
                                <th class="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="ajaxCallInProgress">
                                <td colspan="15">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="!ajaxCallInProgress && consultant_list.length == 0" class="text-center font-weight-bold">
                                <td colspan="15">No Stakeholder Yet!</td>
                            </tr>
                            <tr v-else-if="!ajaxCallInProgress && consultant_list.length" v-for="(consultant,index) in consultant_list" :key="index">
                                <td class="text-center">
                                    <label v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super_admin' || loggedInUser.user_role == 'super admin'" class="custom-control custom-checkbox digi-checkbox text-center" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                        <input class="custom-control-input" type="checkbox" v-model="consultant.checked" @change="selectConsultant($event, consultant.id, index)"
                                        name="select_one" />
                                        <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                        <span class="form-check-description fw-600"></span>
                                    </label>
                                </td>
                                <td class="text-center">
                                    <el-tooltip v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super_admin' || loggedInUser.user_role == 'super admin'" class="item" effect="dark" content="Edit" placement="top">
                                        <button @click="editConsultant(consultant.id)" class="pointer btn-icon pt-3" style="padding:0px!important;">
                                            <img src="/static/images/edit-new.svg" height="14px;">
                                        </button>
                                    </el-tooltip>
                                </td>
                                <td>{{consultant.full_name}}</td>
                                <td></td> 
                                <td style="text-transform: lowercase !important;">{{consultant.personal_email}}</td>
                                <td class="text-capitalize">{{consultant.role.replace('_', ' ')}}
                                    <el-tooltip v-if="loggedInUser.user_role == 'owner' || loggedInUser.user_role == 'super_admin' || loggedInUser.user_role == 'super admin'" class="item" effect="dark" content="Edit Role and Product Permissions" placement="top">
                                        <!-- <i class="icon icon-pencil-box-outline fs-18 text-secondary pointer ml-2" @click="editRoleById(consultant.id)"></i> -->
                                        <button @click="editRoleById(consultant.id)" class="pointer btn-icon pt-3 ml-2" style="padding:0px!important;">
                                            <img src="/static/images/role-edit.png" height="22px;">
                                        </button>
                                    </el-tooltip>
                                </td> 
                                <td>{{consultant.start_date_time || '-'}}</td>
                                <td>{{consultant.end_date_time || '-'}}</td>
                                <td>{{isShareRole(consultant.role) ? formatNumber(consultant.total_shares) : '-'}}</td>
                                <td>{{isShareRole(consultant.role) && consultant.total_invested != null ? currency_symbol + formatNumber(consultant.total_invested) : '-'}}</td>
                                <td class="text-center">{{isShareRole(consultant.role) && consultant.total_investment_count != null ? consultant.total_investment_count : '-'}}</td>
                                <td>
                                    <span v-if="consultant.status" class="status-pill" :class="consultant.status == 'active' ? 'status-active' : 'status-inactive'">{{consultant.status == 'active' ? 'Active' : 'Inactive'}}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <button :disabled="loggedInUser.user_role == 'employee' || loggedInUser.user_role == 'admin' || loggedInUser.user_role == 'consultant'" @click="regeneratePassword(consultant.id)" style="border-radius: 6px !important;" class="btn btn-smm btn-new-secondary text-white">Resend</button>
                                </td>
                                <td class="text-center">
                                    <span :class="{'pointer-events-none':loggedInUser.user_role == 'employee' || loggedInUser.user_role == 'admin' || loggedInUser.user_role == 'consultant'}" @click="enableAccess(consultant)">
                                        <el-switch :disabled="loggedInUser.user_role == 'employee' || loggedInUser.user_role == 'admin' || loggedInUser.user_role == 'consultant'" v-model="consultant.access"></el-switch>
                                    </span>
                                </td>
                                <td class="text-center">
                                    <el-dropdown v-if="isShareRole(consultant.role)" trigger="click" placement="bottom-end" @command="handleAction($event, consultant)">
                                        <span class="pointer action-dots px-2">
                                            <i class="icon icon-dots-vertical fs-20 text-secondary"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="add_investment">Add Investment</el-dropdown-item>
                                            <el-dropdown-item command="investment_history">Investment History</el-dropdown-item>
                                            <!-- <el-dropdown-item v-if="canChangeStatus" command="toggle_status">
                                                <span :class="consultant.status == 'active' ? 'text-danger' : 'text-success'">
                                                    {{consultant.status == 'active' ? 'Deactivate' : 'Activate'}} {{roleLabel(consultant.role)}}
                                                </span>
                                            </el-dropdown-item> -->
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="!ajaxCallInProgress" class="d-flex justify-content-end align-items-center bg-white py-2 pb-10 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                    <multiselect class="diginew-multiselect"
                        :options="pageLimit" :close-on-select="true" v-model.number="limit"
                        open-direction="top" :show-labels="false" placeholder=""
                        style="width: 4.0em !important;padding-right: 10px!important;padding-top: 10px !important;">
                    </multiselect>
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg" style="margin-left: -20px;">
                    <span class="page-info pr-2 pl-6 fw-500" style="height: 2.4rem;line-height: 2.4rem;color: #303031;font-size: 14px;">Per page</span>
                    <button @click="firstPage()" :class="{'not-allowed' : skip == 0}" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                        <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                            <i class="icon-chevron-double-left"></i>
                        </el-tooltip>
                    </button>
                    <button @click="previousPage()" :disabled="skip == 0" :class="{'not-allowed' : skip == 0}" class="pagination-list mt-1 ml-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                            <i class="icon icon-chevron-left"></i>
                        </el-tooltip>
                    </button>
                    <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                    <button @click="nextPage()" :disabled="skip_temp >= total" :class="{'not-allowed' : skip_temp >= total }" class="pagination-list mt-1 mr-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                            <i class="icon icon-chevron-right"></i>
                        </el-tooltip>
                    </button>
                    <button @click="lastPage()" :disabled="temp_total == total" :class="{'not-allowed' : temp_total == total}" class="mt-1 pointer pagination-list">
                        <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                            <i class="icon-chevron-double-right"></i>
                        </el-tooltip>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="display_filters" class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}" style="background-color: #e6ecff !important;height: 250px !important;">
            <filter-data :showfilterData="showfilterData" @hideFilters="hideFilters"></filter-data>
        </div>
        <sweet-modal ref="warning_modal" overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <delete-stakeholder-modal v-if="delete_consultant" @hideDeleteStakeholderModal="hideDeleteStakeholderModal" @deleteStakeholderSuccess="deleteStakeholderSuccess" modal_name='delete_company_modal' ></delete-stakeholder-modal>
        <add-investment v-if="add_investment" modal_name="AddInvestmentList" :submitting="investment_submitting" @addInvestment="submitInvestment" @hideAddInvestment="add_investment = false"></add-investment>
        <investment-history v-if="investment_history" modal_name="InvestmentHistory" :stakeholder_id="selected_stakeholder.id" :stakeholder_name="selected_stakeholder.full_name" @hideInvestmentHistory="investment_history = false"></investment-history>
        <edit-role v-if="edit_role_product" :external_id="external_id" @hideSucessPopup="hideSucessPopup" @hidePopup="hidePopup" modal_name="EditRoleProduct"></edit-role>
    </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners';
const FilterData = () => import('./FilterData');
const EditRole = () => import('./EditRoleProductPopup');
const AddInvestment = () => import('./AddInvestmentModal');
const InvestmentHistory = () => import('./InvestmentHistoryModal');
import { SweetModal } from 'sweet-modal-vue';
import stakeholder from "../mixins/stakeholder.js"
import DeleteStakeholderModal from './DeleteStakeholderModal.vue';
export default({
    data(){
        return{
            warning_msg: '',
            success_msg: '',
            ajaxCallInProgress: false,
            limit:10,
            pageLimit: [],
            showfilterData: {
                started_on:"",
                department_head:[],
                business_unit_id:[],
                department_name:[],
            },
            filterData: {
                started_on:"",
                department_head:[],
                business_unit_id:[],
                department_name:[]
            },
            display_filters: false,
            hide_filters: false,
            skip: 0,
            limit: 10,
            total: 0,
            skip_temp:0,
            temp_total:0,
            consultant_list: [],
            search_key: "",
            delete_consultant: false,
            check_all: false,
            consultant_selected: [],
            group_type: 'consultant',
            role: 'banker',
            edit_role_product: false,
            external_id: '',
            add_investment: false,
            investment_history: false,
            selected_stakeholder: {},
            investment_submitting: false
        }
    },
    mixins:[stakeholder],
    components: {
        EditRole,
        AddInvestment,
        InvestmentHistory,
        FilterData,
        SweetModal,
        HalfCircleSpinner,
        DeleteStakeholderModal
    },
    methods: {
        isShareRole(role) {
            return ['investor', 'board_member', 'share_holder'].includes(role);
        },
        roleLabel(role) {
            return role.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase());
        },
        handleAction(command, consultant) {
            this.selected_stakeholder = consultant;
            if (command == 'add_investment') {
                this.add_investment = true;
                setTimeout(() => {
                    this.$modal.show('AddInvestmentList');
                }, 100);
            } else if (command == 'investment_history') {
                // Remount the popup each time so it loads the selected stakeholder's history.
                this.investment_history = false;
                this.$nextTick(() => {
                    this.investment_history = true;
                    setTimeout(() => {
                        this.$modal.show('InvestmentHistory');
                    }, 100);
                });
            } else if (command == 'toggle_status') {
                this.enableAccess(consultant);
            }
        },
        async submitInvestment(investment) {
            this.investment_submitting = true;
            try {
                let payload = {
                    investment_date: investment.investment_date,
                    shares_purchased: investment.shares_purchased,
                    amount_invested: Number(investment.amount_invested),
                    reference_id: investment.reference_id,
                };
                if (investment.notes) {
                    payload.notes = investment.notes;
                }
                let response = await this.addStakeholderInvestment({ stake_holder_id: this.selected_stakeholder.id, investment: payload })
                this.investment_submitting = false;
                this.$modal.hide('AddInvestmentList');
                this.add_investment = false;
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadStakeholder();
                }, 2000);
            }
            catch(err) {
                this.investment_submitting = false;
                this.warning_msg = err;
                this.$refs.warning_modal.open();
            }
        },
        hideSucessPopup(){
            this.edit_role_product = false
            setTimeout(() => {
                this.$modal.hide('EditRoleProduct')
                this.loadStakeholder();
            }, 1000);
        },
        hidePopup(){
            this.edit_role_product = false
            setTimeout(() => {
                this.$modal.hide('EditRoleProduct')
            }, 1000);
        },
        editRoleById(id){
            this.external_id = id
            this.edit_role_product = true
            setTimeout(() => {
                this.$modal.show('EditRoleProduct')
            }, 1000);
        },
        filterBy(type){
            this.role = type
            this.loadStakeholder();
        },
        clearSearch(){
            this.search_key = ""
            this.loadStakeholder();
        },
        goToCompanyList() {
            this.$router.push('/company/view/cmpid/' + this.$route.params.company_id);
        },
        hideDeleteStakeholderModal() {
            this.delete_consultant = false;
        },
        async deleteStakeholderSuccess() {
            this.deleteComp();
        },
        showDeleteComp() {
            if(this.consultant_selected.length){
                this.delete_consultant = true;
                setTimeout(() => {
                    this.$modal.show('delete_company_modal');
                }, 500);
            }
        },
        async deleteComp() {
            try {
                let params = {
                    id: this.consultant_selected
                }
                let response = await this.deleteStakeholder(params)
                if(response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    this.consultant_selected = [];
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.loadStakeholder();
                    }, 2000);
                }
            }
            catch(err) {
                // this.ajax_call_in_progress = false;
                // console.log(err)
                this.warning_msg = err;
                this.$refs.warning_modal.open();
            }
        },
        selectConsultant(event, id) {
            if (event.target.checked) {
                this.consultant_selected.push(id);
            } else {
                let index = this.consultant_selected.indexOf(id);
                if (index > -1) {
                    this.consultant_selected.splice(index, 1);
                }
            }
            if (this.consultant_selected.length === this.consultant_list.length) {
                this.check_all = true;
            } else {
                this.check_all = false;
            }
        },
        checkAll(event) {
            if (event.target.checked === true) {
                this.consultant_list.forEach((consultant, index) => {
                    this.consultant_list[index].checked = true;
                    this.consultant_selected.push(consultant.id);
                })
            } else {
                this.consultant_list.forEach((consultant, index) => {
                    this.consultant_list[index].checked = false;
                })
                this.consultant_selected = [];
            }
        },
        showFilters() {
            if (this.display_filters) {
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            } else {
                this.display_filters = true
            }
        },
        hideFilters() {
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        createNew(){
            this.$router.push('/stakeholder/createstakeholder/cmpid/'+this.$route.params.company_id);
        },
        editConsultant(id) {
            this.$router.push(`/stakeholder/editstakeholder/cmpid/${this.$route.params.company_id}/${id}`);
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.loadStakeholder();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.loadStakeholder();
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.loadStakeholder();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.loadStakeholder();
        },
        async loadStakeholder(){
            this.ajaxCallInProgress = true
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_key,
                role: this.role,
                company_id: this.$route.params.company_id
            }
            let response = await this.getStakeholderList(params.skip, params.limit, params.search_key,params.company_id, params.role)
            this.consultant_list = response.response
            this.consultant_list.forEach(x => {
                x['checked'] = false
                if(x.status == 'active'){
                    x['access'] = true
                }
                else{
                    x['access'] = false
                }
            })
            this.total = response.total_count;
            this.ajaxCallInProgress = false
        },
        async regeneratePassword(id){
            let params = {
                consultant_id: id
            }
            let response = await this.regenerateStakeholder(params)
            this.success_msg = response.message
            this.$refs.success_modal.open();
            setTimeout(() => {
                this.$refs.success_modal.close();
                this.loadStakeholder();
            }, 2000);
        },
        async enableAccess(consultant){
            let params = {
                status: consultant.status == "active" ? "terminate" : "active"
            }
            let response = await this.editStakeholder(params,consultant.id)
            this.success_msg = response.message
            this.$refs.success_modal.open();
            setTimeout(() => {
                this.$refs.success_modal.close();
                this.loadStakeholder();
            }, 2000);
        }
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        canChangeStatus() {
            return !['employee', 'admin', 'consultant'].includes(this.loggedInUser.user_role);
        },
    },
    mounted(){
        this.role = ''
        // for (let i = 1; i <= 50; i++) {
        //     i += 9
        //     this.pageLimit.push(i);
        // }
        this.loadStakeholder()
    },
    created() {
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
    },
    watch: {
        limit: function(){
            this.loadStakeholder()
        },
    }
})
</script>
<style scoped>
    .status-pill {
        display: inline-flex;
        align-items: center;
        padding: 4px 12px;
        border-radius: 14px;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
    }
    .status-pill::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 6px;
        background-color: currentColor;
    }
    .status-active {
        color: #1e8e3e;
        background-color: #e6f4ea;
    }
    .status-inactive {
        color: #e82828;
        background-color: #fdeaea;
    }
.link-name{
    color:#00448b
}
.decoration-none{
    text-decoration: none;
}
.table-view-start {
    background-color: #fff;
}
.search-input-field {
    padding: 8px 9.4px 8px 30px;
    border-radius: 18px !important;
    background-color: #fff;
    width: 100%;
}
.table-start {
    background-color: #fff;
    padding-top: 5px;
    border-radius: 8px;
    overflow-x: auto !important;
    scroll-behavior: auto !important;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.table-start::-webkit-scrollbar {
    display: none;
    width: 0px;
    height: 0px;
}
.scm-filters{
    width: 300px !important;
    height: 300px !important;
    right:100px;
}
.btn-new-green {
    color: #fff;
    background-color: #128807;
    border-radius: 5px;
}
.pointer-events-none {
    pointer-events: none;
}
.not-allowed{
    cursor: no-drop !important;
}
.text-secondary{
    font-weight: 600 !important;
}
</style>